import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AbstractControl, FormControl, FormGroup, ValidatorFn, Validators } from '@angular/forms';
import { AtivacaoSectionCardComponent } from '@shared/components/ativacao-section-card/ativacao-section-card.component';
import { FormulaCatalogoItemStruct } from '@shared/services/structs/formula/formula-catalogo-item.struct';
import { CodigoCreditoPresumidoStruct } from '@shared/services/structs/motor-fiscal/codigo-credito-presumido.struct';
import { RegraTributariaCreditoPresumidoOperacaoSectionComponent } from './sections/credito-presumido-operacao-section/regra-tributaria-credito-presumido-operacao-section.component';
import { RegraTributariaCreditoPresumidoIbsSectionComponent } from './sections/credito-presumido-ibs-section/regra-tributaria-credito-presumido-ibs-section.component';
import { RegraTributariaCreditoPresumidoCbsSectionComponent } from './sections/credito-presumido-cbs-section/regra-tributaria-credito-presumido-cbs-section.component';

const minimoZero = Validators.min(0);

/** Aba Crédito Presumido: ativação do tributo e as seções de operação, IBS e CBS. */
@Component({
    selector: 'app-regra-tributaria-credito-presumido-tab',
    standalone: true,
    imports: [
        CommonModule,
        AtivacaoSectionCardComponent,
        RegraTributariaCreditoPresumidoOperacaoSectionComponent,
        RegraTributariaCreditoPresumidoIbsSectionComponent,
        RegraTributariaCreditoPresumidoCbsSectionComponent,
    ],
    templateUrl: './regra-tributaria-credito-presumido-tab.component.html',
    styleUrl: './regra-tributaria-credito-presumido-tab.component.css',
})
export class RegraTributariaCreditoPresumidoTabComponent implements OnInit {
    @Input({ required: true }) form!: FormGroup;
    @Input() formulasOperacao: FormulaCatalogoItemStruct[] = [];
    @Input() formulasIbs: FormulaCatalogoItemStruct[] = [];
    @Input() formulasCbs: FormulaCatalogoItemStruct[] = [];
    @Input() codigosCreditoPresumido: CodigoCreditoPresumidoStruct[] = [];

    ngOnInit(): void {
        // Ao ativar o Crédito Presumido, o código da operação é obrigatório; o % de cada sub-seção
        // (IBS/CBS) é obrigatório apenas quando o tributo E a sub-seção estão ativos.
        this.ativacaoControl.valueChanges.subscribe(() => this.sincronizarObrigatoriedade());
        this.ibsForm.get('isAtivo')?.valueChanges.subscribe(() => this.sincronizarObrigatoriedade());
        this.cbsForm.get('isAtivo')?.valueChanges.subscribe(() => this.sincronizarObrigatoriedade());
        this.sincronizarObrigatoriedade();
    }

    private sincronizarObrigatoriedade(): void {
        const ativo = !!this.ativacaoControl.value;
        this.aplicarObrigatorio(this.cpForm.get('cCredPres'), ativo, [Validators.required]);
        // Percentual preenchido é não vazio: zero é aceito, negativo não (o teto de 100 vem da máscara).
        this.aplicarObrigatorio(this.ibsForm.get('pCredPres'), ativo && !!this.ibsForm.get('isAtivo')?.value, [Validators.required, minimoZero]);
        this.aplicarObrigatorio(this.cbsForm.get('pCredPres'), ativo && !!this.cbsForm.get('isAtivo')?.value, [Validators.required, minimoZero]);
    }

    private aplicarObrigatorio(control: AbstractControl | null, obrigatorio: boolean, validadores: ValidatorFn[]): void {
        if (!control) return;
        if (obrigatorio) {
            control.addValidators(validadores);
        } else {
            control.removeValidators(validadores);
        }
        control.updateValueAndValidity({ emitEvent: false });
    }

    public get cpForm(): FormGroup {
        return this.form.get('creditoPresumido') as FormGroup;
    }

    public get ativacaoControl(): FormControl {
        return this.cpForm.get('isAtivo') as FormControl;
    }

    public get ibsForm(): FormGroup {
        return this.cpForm.get('ibs') as FormGroup;
    }

    public get cbsForm(): FormGroup {
        return this.cpForm.get('cbs') as FormGroup;
    }
}
